export const PERSONA_FISICA = 'PERSONA FÍSICA';
export const PERSONA_JURIDICA = 'PERSONA JURÍDICA';